/**
 * @see none.js for detailed getter and action descriptions
 */

// constants as defined in RevoXef’s App\Services\Fiscal\FiscalCountry
const FISCAL_COUNTRIES = [
  { key: 0, module: 'none' },
  { key: 1, module: 'spain' },
  { key: 3, module: 'france' },
  { key: 9, module: 'ticketbai' },
  { key: 13, module: 'verifactu' },
]

// MODULES
import none from './none'
import spain from './spain'
import france from './france'
import ticketbai from './ticketbai'
import verifactu from './verifactu'

const modules = {
  none,
  spain,
  france,
  ticketbai,
  verifactu,
}

const state = () => ({
  /**
   * Fiscal information dialog visibility.
   * @type Boolean
   */
  show: false,
})

const getters = {
  _module: (state, getters, rootState) => {
    const key = rootState.rummage.data.FiscalSettings?.[0]?.fiscalCountry ?? 0
    return FISCAL_COUNTRIES.find(o => o.key === key)?.module ?? 'none'
  },

  get: (state, getters) => prop => getters[`${getters._module}/${prop}`],

  business: (state, getters, rootState, rootGetters) => prop =>
    getters[`${getters._module}/business`](prop)
    ?? rootGetters['rummage/business'](prop),

  info: (state, getters) => getters[`${getters._module}/fiscalInfo`] ?? [],

  test: (state, getters, rootState) => !! rootState.rummage.data.FiscalSettings?.[0]?.test,

  config: (state, getters, rootState) => prop => {
    const settings = rootState.rummage.data.FiscalSettings?.[0]
    return settings?.config && prop ? settings?.config[prop] : settings.config
  },

  contentPrice: (state, getters) => payload => getters[`${getters._module}/contentPrice`](payload),

  shouldAddReason: (state, getters) => getters[`${getters._module}/shouldAddReason`] ?? false,
  shouldSignInvoice: (state, getters) => getters[`${getters._module}/shouldSignInvoice`] ?? false,
}

const mutations = {
  show (state) {
    state.show = true
  },
  hide (state) {
    state.show = false
  },
}

const actions = {
  open ({ commit }) {
    setTimeout(() => commit('show'), 150)
  },
  close ({ commit }) {
    commit('hide')
  },
  signPrintCheck ({ dispatch, getters }, params) {
    return dispatch(`${getters['_module']}/signPrintCheck`, params)
  },
  signInvoice ({ dispatch, getters }, invoice) {
    return dispatch(`${getters['_module']}/signInvoice`, invoice)
  },
  print ({ dispatch, getters }, { target, data }) {
    return dispatch(`${getters['_module']}/print${target}`, data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules
}
